export class TypeCustomer {
    id: number;
    name: string;
    abbreviation: string;
    observation: string;

    constructor() { }
}

export class TypeCustomerForm {
    id: number;
    name: string;
    abbreviation: string;
    observation: string;

    constructor() { }
}